import { useState } from 'react';
import { elementDot } from '@/components/base/ElementTag';

interface CharacterFilterProps {
  elements: string[];
  element: string;
  onElement: (value: string) => void;
  rarities: { value: string; label: string }[];
  rarity: string;
  onRarity: (value: string) => void;
  total: number;
}

export default function CharacterFilter({
  elements,
  element,
  onElement,
  rarities,
  rarity,
  onRarity,
  total,
}: CharacterFilterProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const chipClass = (active: boolean) =>
    `inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors cursor-pointer ${
      active
        ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
        : 'bg-background-50 text-foreground-600 hover:bg-background-200'
    }`;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between gap-3 border-b border-background-200 px-4 py-3 md:hidden">
        <div className="flex items-center gap-2 text-sm text-foreground-600">
          <i className="ri-filter-3-line text-primary-600"></i>
          共 <span className="font-semibold text-foreground-900">{total}</span> 位角色
        </div>
        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-sm font-medium text-foreground-700"
        >
          <i className={mobileOpen ? 'ri-close-line' : 'ri-equalizer-line'}></i>
          筛选
        </button>
      </div>

      <div className={`${mobileOpen ? 'block' : 'hidden'} px-4 py-4 md:block md:px-5`}>
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:gap-8">
          <div className="flex flex-wrap items-center gap-2">
            <span className="hidden text-sm text-foreground-500 md:inline">元素：</span>
            <button type="button" onClick={() => onElement('全部')} className={chipClass(element === '全部')}>
              全部
            </button>
            {elements.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => onElement(item)}
                className={chipClass(element === item)}
              >
                <span className={`h-2 w-2 rounded-full ${elementDot(item)}`}></span>
                {item}
              </button>
            ))}
          </div>

          <div className="flex flex-wrap items-center gap-2 md:ml-auto">
            <span className="hidden text-sm text-foreground-500 md:inline">稀有度：</span>
            {rarities.map((item) => (
              <button
                key={item.value}
                type="button"
                onClick={() => onRarity(item.value)}
                className={chipClass(rarity === item.value)}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}